import React, { useEffect, useState } from 'react';
import { IconButton, Button } from '@mui/material';
import { selectHLSState, useHMSActions, useHMSStore } from '@100mslive/react-sdk'
import { selectIsLocalAudioEnabled, selectIsLocalVideoEnabled, selectLocalPeer } from '@100mslive/react-sdk'
import { IoVideocamOutline, IoVideocamOffOutline, IoMicOffOutline, IoLogOutOutline, IoStopCircleOutline } from 'react-icons/io5';
import { MdOutlineMicNone, MdOutlinePodcasts } from 'react-icons/md'
import { toast } from 'react-toastify';

const LiveUpdate = () => {
    const [islive, setIsLive] = useState();
    const [status, setStatus] = useState();

    const API_KEY = "os_v2_app_2emfrpferfejpptmafnbvylv36nr4pb6n2wurp4itcsfzzkuzck6smpm3gllsk3wibdt224zu34o3ozcmncy53j7qvecpogapt2cnby";
    const ONESIGNAL_APP_ID = "d11858bc-a489-4897-be6c-015a1ae175df";
    const BASE_URL = "https://onesignal.com/api/v1";


    const sendNofification = () => {
        const body = {
            app_id: ONESIGNAL_APP_ID,
            included_segments: ['Subscribed Users'],
            data: {
                foo: 'bar',
            },
            contents: {
                en: 'Testing Live',
            },
        };

        // আরিফ বিল্লাহ হজরত মাওলানা মুফতি শফী সাহেব লাইভে আছেন, সবাই জয়েন করুন

        if (!islive) {
            fetch('https://onesignal.com/api/v1/notifications', {
                method: "POST",
                'url': BASE_URL,
                'headers': {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${API_KEY}`,
                },
                body: body ? JSON.stringify(body) : null

            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                })
        }
    }

    const handleLiveStatus = (stat) => {
        setStatus(stat)
        const data = { live: stat }
        fetch(`https://madrumi.thakurgaonexpress.com/getlive/63c649e5160ba05ec6fb3e81`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                toast.success(`লাইভ ${stat ? 'চালু' : 'বন্ধ'} হয়েছে`)
                sendNofification();
            })
    }




    useEffect(() => {
        fetch('https://madrumi.thakurgaonexpress.com/getlive')
            .then(res => res.json())
            .then(data => setIsLive(data[0]?.live))
    }, [status, setStatus])


    return (
        <div className='mt-8'>
            <h1> এই মুহূর্তে লাইভ {islive === true ? <p className='text-xs font-fold text-green-700 z-20 mb-4'>চালু আছে</p> : <p className='text-xs font-bold z-20 mb-4 text-red-700'>বন্ধ আছে</p>}</h1>
            {islive === true ? <Button onClick={() => handleLiveStatus(false)}>
                <IoStopCircleOutline /> লাইভ বন্ধ করুন
            </Button> : <Button onClick={() => handleLiveStatus(true)}>
                <MdOutlinePodcasts /> লাইভ চালু করুন
            </Button>}
        </div>
    );
};

export default LiveUpdate;